import { defineStore } from 'pinia';
import type { RaffleStatus } from '~/handlers/ports/api-fetch-giratudo-status.port';
import type { RaffleLeaderboardResponse } from '~/handlers/ports/api-fetch-giratudo-leaderboard.port';
import type { RaffleHistoryResponse } from '~/handlers/ports/api-fetch-giratudo-history.port';
import type { RafflePrizesResponse } from '~/handlers/ports/api-fetch-giratudo-prizes.port';

export const useGiratudoStore = defineStore('ap.giratudo', () => {
  const isOpen = ref(false);

  const raffleActive = ref(false);
  const alreadyParticipated = ref(false);
  const eligible = ref(false);
  const raffleEndTime = ref<string | null>(null);
  const participationEnabled = ref(true);
  const statusLoading = ref(false);
  const participateError = ref<string | null>(null);

  const leaderboard = ref<RaffleLeaderboardResponse>({
    data: [],
    currentPage: 1,
    totalPages: 0,
    userPosition: null,
  });

  const leaderboardLoading = ref(false);

  const history = ref<RaffleHistoryResponse>({
    data: [],
    currentPage: 1,
    totalPages: 0,
  });

  const historyLoading = ref(false);

  const prizes = ref<RafflePrizesResponse>({
    data: [],
    currentPage: 1,
    totalPages: 0,
  });

  const prizesLoading = ref(false);

  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  function setStatus(data: RaffleStatus) {
    raffleActive.value = data.raffleActive;
    alreadyParticipated.value = data.alreadyParticipated;
    eligible.value = data.eligible;
    raffleEndTime.value = data.raffleEndTime;
    participationEnabled.value = data.participationEnabled;
  }

  function setAlreadyParticipated(value: boolean) {
    alreadyParticipated.value = value;
  }

  function setStatusLoading(value: boolean) {
    statusLoading.value = value;
  }

  function setParticipateError(message: string | null) {
    participateError.value = message;
  }

  function setLeaderboard(data: RaffleLeaderboardResponse) {
    leaderboard.value = data;
  }

  function setLeaderboardLoading(value: boolean) {
    leaderboardLoading.value = value;
  }

  function setHistory(data: RaffleHistoryResponse) {
    history.value = data;
  }

  function setHistoryLoading(value: boolean) {
    historyLoading.value = value;
  }

  function setPrizes(data: RafflePrizesResponse) {
    prizes.value = data;
  }

  function setPrizesLoading(value: boolean) {
    prizesLoading.value = value;
  }

  return {
    isOpen,
    raffleActive,
    alreadyParticipated,
    eligible,
    raffleEndTime,
    participationEnabled,
    statusLoading,
    participateError,
    leaderboard,
    leaderboardLoading,
    history,
    historyLoading,
    prizes,
    prizesLoading,
    open,
    close,
    setStatus,
    setStatusLoading,
    setAlreadyParticipated,
    setParticipateError,
    setLeaderboard,
    setLeaderboardLoading,
    setHistory,
    setHistoryLoading,
    setPrizes,
    setPrizesLoading,
  };
});
